<script>
	export let cols = null;
	export let scale = "md";
	export let style = null;

	let className = $$props.class ? $$props.class : "";

	cols = cols ? `-${cols}` : "";
	scale = scale ? `-${scale}` : "";
	scale = cols == "" ? "" : scale;
</script>

<div class="col{scale}{cols}{!className ? '' : ' ' + className}" {style}>
	<slot></slot>
</div>

<style>
	div {
		margin-top: 20px;
	}

	@media (min-width: 768px) {
		div {
			margin-top: 0;
		}
	}
</style>
